module.exports = __webpack_public_path__ + "img/reviewicon.6d77aab0.svg";